export default __webpack_public_path__ + "static/media/success-check.0206779b.gif";